import React from 'react';
import PropTypes from 'prop-types';

const Step = ({ children }) => {
  return <div>{children}</div>;
};

Step.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export { Step };
